module.exports = __webpack_public_path__ + "static/media/8a Pistol Grip.4ac18b0e.jpg";